import React from 'react';
import './removeAccountForm.css';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function RemoveAccountForm() {
  const apiUrl = "https://api.insulimit.com";
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [pincode, setPincode] = useState('');
  const [step, setStep] = useState(1);
  const [message, setMessage] = useState('');

  const handleEmailSubmit = async () => {
    try {
      const response = await fetch(`${apiUrl}/auth/remove-account/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to send email');
      }

      setStep(2);
      setMessage('');
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  const handlePincodeSubmit = async () => {
    try {
      const response = await fetch(`${apiUrl}/auth/remove-account/`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, pincode }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || t('Failed to delete account'));
      }

      setMessage(t('Account successfully deleted'));
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div>
      <p>{t('accountDeletionDisclaimer', 'To permanently delete your account, enter your email address, and we will send you a message with a PIN code.')}</p>
      {step === 1 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleEmailSubmit();
          }}
        >
          <input
            type="email"
            placeholder="Email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button className="submit" type="submit">{t('Send email')}</button>
        </form>
      )}
      {step === 2 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handlePincodeSubmit();
          }}
        >
          <input
            type="text"
            placeholder="PIN code"
            className="input"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            required
          />
          <button className="submit" type="submit">{t('Delete account')}</button>
        </form>
      )}
      {message && <p className="error">{message}</p>}
    </div>
  );
}
